<template>
  <div :class="className">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'setting-col',

  props: {
    widthScale: {
      type: Number,
      default: 1
    }
  },

  computed: {
    className () {
      let smWidth = 6 * this.widthScale
      let mdWidth = 4 * this.widthScale
      let lgWidth = 3 * this.widthScale

      return 'col-sm-' + smWidth + ' col-md-' + mdWidth + ' col-lg-' + lgWidth
    }
  }
}
</script>


// WEBPACK FOOTER //
// setting-col.vue?3424205f